import axios from "axios";

import { getImidDataUrl, getImidDataAPIKey } from "utils/api-util";

const API_KEY = "prIXl0KECAoWSYbeLWCS30pz0Mwxk0w1oAd2tEsg";

const baseUrl = getImidDataUrl();
const apiKey = getImidDataAPIKey();

const getData = async (deviceData) => {
  // axios.defaults.headers.get["x-api-key"] =
    // apiKey;


  ///dev/imid-device/history?
  //deviceId=000300006438&
  //attribute=activeEnergyTotal&
  //from=2023-03-10T00:00:00&
  //to=2023-03-24T22:00:00&
  //type=ProfileData
  // return await fetch(`${baseUrl}/history?deviceId=${deviceData.deviceId}&attribute=${deviceData.attribute}&from=${deviceData.from}&to=${deviceData.to}&type=${deviceData.type}`, {
  //   headers: {
  //     "x-api-key": API_KEY,
  //   }
  // });

  const {type,size} = getType(deviceData.type);


  try {
    return await axios.get(`${baseUrl}/device/history`, {
      params: {
        deviceId: deviceData.deviceId,
        attribute: deviceData.attribute,
        from: deviceData.from,
        to: deviceData.to,
        type,
        size,
      },
    });
  } catch (error) {
    throw new Error(error.response.data.message);
  }

  // return result.data;
};

const getType = (range) => {
  if (range === "dayTotal") {
    return {type:"ProfileData",size:24};
  } else if (range === "lastHour") {
    return {type:"ProfileData",size:24};
  } else if (range === "today") {
    return {type:"ProfileData",size:24};
  } else if (range === "yesterday") {
    return {type:"ProfileData",size:24};
  } else if (range === "thisWeek") {
    return {type:"DailyBillingData",size:8};
  } else if (range === "lastWeek") {
    return {type:"DailyBillingData",size:8};
  } else if (range === "2Weeks") {
    return {type:"DailyBillingData",size:15};
  } else if (range === "thisMonth") {
    return {type:"DailyBillingData",size:31};
  } else if (range === "lastMonth") {
    return {type:"DailyBillingData",size:31};
  }
}

const getLastMonthUsage = async (deviceId, from, to) => {

  console.log(`deviceId: ${deviceId}, from: ${from}, to: ${to}`)
  try {
    const result = await axios.get(`${baseUrl}/device/history`, {
      params: {
        deviceId,
        attribute: "activeEnergyTotal",
        type: "MonthlyBillingData",
        from,
        to
      },
    });
    console.log("month billing data: " , result)
    const values = result?.data?.items || [];
    // const data = JSON.parse(obj);
    // console.log("Value: " , data);
    // const values = data?.items || []
    console.log("Billing values: " , values)
    if (values.length > 0) {
      return values[0].value
    }
    return undefined;
  } catch (error) {
    console.log(error);
  }

}

const transformData = (data, parameter) => {
  const d = JSON.parse(data);
  console.log("JSON Data: ", d);
  const resp = [
    {
      id: parameter,
      color: "hsl(258, 70%, 50%)",
      data: [],
    },
  ];

  console.log("response: ", resp[0]);
  d.historicalRecords[parameter].billingValuesList.forEach((e, i) => {
    resp[0].data.push({ y: e.value, x: new Date(e.timestamp) });
  });

  console.log("formated data")
  console.log(resp)
  return resp;
};

const transformDataForBarChart = (data, parameter) => {
  const d = JSON.parse(data);
  console.log("JSON Data: ", d);
  const resp = [
    {
      indexBy: "timeStamp",
      yLegend: "Date/time",
      xLegend: "consumption",
      keys: ["Energy consumed", "amount"], 
      data: [],
    },
  ];

  console.log("response: ", resp[0]);
  d.historicalRecords[parameter].billingValuesList.forEach((e, i) => {
    resp[0].data.push({ y: e.value, x: new Date(e.timestamp) });
  });

  console.log("formated data")
  console.log(resp)
  return resp;
};

export { getData, transformData, transformDataForBarChart, getLastMonthUsage};
